<template>
<div class="chapter">
<div class="inner_page">
      ﻿<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/><meta content="text/html; charset=UTF-8"/><title>Daily Light: Morning &amp; Evening</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="ct0" id="page1"><a href="#/chapter1a#cc2" id="dd2"><i>January</i></a></p>
<p class="ser1"><img alt="January" class="maxwidth" src="images/9781400322572_IN_0005_002.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?40e280ae